export default [
  {
    path: '/',
    name: 'home',
    component: () => import('@/views/dashboard/index.vue'),
    meta: {
        resource: 'dashboard',
        action: 'read'
    },
  },
  // {
  //   path: '/settings/settings/edit',
  //   name: 'settings-edit',
  //   component: () => import('@/views/setting/setting/settings-edit/SettingsEdit.vue'),
  //   meta: {
  //       resource: 'Auth',
  //       action: 'read'
  //   },
  // },
  {
    path: "/users/list",
    name: "users-list",
    component: () => import("@/views/user/listTab.vue"),
    meta: {
      action: "read",
      resource: "Auth",
    },
  },
  {
    path: "/customer/view/:id",
    name: "customer-view",
    component: () => import("@/views/user/customer/customer-view/customerView.vue"),
    meta: {
      action: "read",
      resource: "setting_customers",
    },
  },
  // {
  //   path: "/users/view/:id",
  //   name: "users-view",
  //   component: () => import("@/views/user/user/users-view/UsersView.vue"),
  //   meta: {
  //     action: "read",
  //     resource: "setting-users",
  //   },
  // },
  // {
  //   path: "/users/edit/:id",
  //   name: "users-edit",
  //   component: () => import("@/views/user/user/users-edit/UsersEdit.vue"),
  //   meta: {
  //     action: "update",
  //     resource: "setting-users",
  //   },
  // },
  // {
  //   path: "/users/create",
  //   name: "users-create",
  //   component: () => import("@/views/user/user/users-edit/UsersEdit.vue"),
  //   meta: {
  //     action: "create",
  //     resource: "setting-users",
  //   },
  // },
  // {
  //   path:'/roles/list',
  //   name: 'roles-list',
  //   component:() => import('@/views/user/role/roles-list/RolesList.vue'),
  //   meta:{
  //     action: 'read',
  //     resource: 'setting-roles'
  //   }
  // },
  // {
  //   path:'/roles/edit/:id',
  //   name: 'roles-edit',
  //   component:() => import('@/views/user/role/roles-edit/RolesEdit.vue'),
  //   meta:{
  //     action: 'update',
  //     resource: 'setting-roles'
  //   }
  // },
  {
    path: "/customer/edit/:id",
    name: "customer-edit",
    component: () => import("@/views/user/customer/customer-edit/customerEdit.vue"),
    meta: {
      action: "update",
      resource: "setting_customers",
    },
  },
  {
    path: "/customer/create",
    name: "customer-create",
    component: () => import("@/views/user/customer/customer-edit/customerEdit.vue"),
    meta: {
      action: "create",
      resource: "setting_customers",
    },
  },
  {
    path: "/staff/edit/:id",
    name: "staff-edit",
    component: () => import("@/views/user/staff/staff-edit/staffEdit.vue"),
    meta: {
      action: "update",
      resource: "setting_staffs",
    },
  },
  // {
  //   path: "/staff/view/:id",
  //   name: "staff-view",
  //   component: () => import("@/views/user/staff/staff-view/staffView.vue"),
  //   meta: {
  //     action: "read",
  //     resource: "setting-users",
  //   },
  // },
  {
    path: "/staff/create",
    name: "staff-create",
    component: () => import("@/views/user/staff/staff-edit/staffEdit.vue"),
    meta: {
      action: "create",
      resource: "setting_staffs",
    },
  },
  {
    path: "/supplier/edit/:id",
    name: "supplier-edit",
    component: () => import("@/views/user/supplier/supplier-edit/supplierEdit.vue"),
    meta: {
      action: "update",
      resource: "setting_suppliers",
    },
  },
  {
    path: "/supplier/create",
    name: "supplier-create",
    component: () => import("@/views/user/supplier/supplier-edit/supplierEdit.vue"),
    meta: {
      action: "create",
      resource: "setting_suppliers",
    },
  },

  {
    path: "/login",
    name: "auth-login",
    component: () => import("@/views/pages/authentication/Login.vue"),
    meta: {
      layout: "full",
      resource: "Auth",
      redirectIfLoggedIn: true,
    },
  },
  {
    path: "/forgot",
    name: "auth-forgot-password",
    component: () => import("@/views/pages/authentication/forgot-password.vue"),
    meta: {
      layout: "full",
      resource: "Auth",
      redirectIfLoggedIn: true,
    },
  },
  {
    path: "/force-change-password",
    name: "force-password",
    component: () => import("@/views/pages/authentication/ForceChangePassword.vue"),
    meta: {
      layout: "full",
      resource: "Auth",
    },
  },
  // {
  //   path: "/",
  //   name: "home",
  //   component: () => import("@/views/user/users-list/UsersList.vue"),
    /*
        meta: {
          pageTitle: 'Home',
          breadcrumb: [
            {
              text: 'Home',
              active: true,
            },
          ],
        },
        */
  // },
  {
    path: "/error-404",
    name: "error-404",
    component: () => import("@/views/error/Error404.vue"),
    meta: {
      layout: "full",
    },
  },
  {
    path: "/pages/not-authorized",
    name: "not-authorized",
    // ! Update import path
    component: () => import("@/views/pages/miscellaneous/NotAuthorized.vue"),
    meta: {
      layout: "full",
      action: "read",
      resource: "Auth",
    },
  },
  {
    path: "*",
    redirect: "error-404",
  },
];
